import { FONT_FAMILIES } from '../../theme/material/constants';
import borders from '../../theme/borders';
import styled from '@emotion/styled';
import { isDarkMode } from '../../utils/helpers';
import colors from '../../theme/colors';

export const VerifyEmailHeader = styled('h3')({
  width: '100%',
  color: '#E21D4A',
  textAlign: 'center',
  leadingTrim: 'both',
  textEdge: 'cap',
  fontFamily: FONT_FAMILIES.primary,
  fontSize: 24,
  fontStyle: 'normal',
  fontWeight: 700,
  lineHeight: 'normal',
  letterSpacing: '-0.48px',
  margin: 0,
  marginTop: 38,
  marginBottom: 5,
});

export const VerifyEmailSubHeader = styled('p')({
  color: isDarkMode() ? '#AFB0B1' : '#595959',
  textAlign: 'center',
  leadingTrim: 'both',
  textEdge: 'cap',
  fontFamily: FONT_FAMILIES.primary,
  fontSize: 15,
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: 'normal',
  letterSpacing: '-0.3px',
  margin: 0,
  marginBottom: 5,
});

export const VerifyEmailDisplay = styled('p')({
  color: isDarkMode() ? '#AFB0B1' : '#595959',
  textAlign: 'center',
  leadingTrim: 'both',
  textEdge: 'cap',
  fontFamily: FONT_FAMILIES.primary,
  fontSize: 15,
  fontStyle: 'normal',
  fontWeight: 700,
  lineHeight: 'normal',
  letterSpacing: '-0.3px',
  margin: 0,
  marginBottom: 20,
});

export const ButtonContainer = styled('div')({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingTop: 14,
  marginTop: 20,
});

export const CancelSkipButtonContainer = styled('div')({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: '#8392A7',
  paddingBottom: 20,
});

export const CancelSkipButtonSeparator = styled('div')({
  margin: '0 15px',
  fontSize: 12,
});

export const mobileOverlayStyle = {
  borderRadius: 10,
  height: '100%',
  width: '90%',
  padding: '0 10%',
  left: '-5%',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
};

export const mobileContentStyle = {
  borderRadius: 10,
  maxHeight: 600,
  top: '50%',
  height: 'auto',
  transform: 'translate(0, -50%)',
};

export const LineSeparator = styled('div')(() => {
  const theme = isDarkMode() ? 'dark' : 'light';

  return {
    height: 1,
    borderTop: `1px dashed ${borders[theme].primary}`,
    margin: '10px 0',
  };
});

export const VerifySuccessDisplay = styled('h3')({
  color: '#24A83A',
  textAlign: 'center',
  leadingTrim: 'both',
  textEdge: 'cap',
  fontFamily: FONT_FAMILIES.primary,
  fontSize: 22,
  fontStyle: 'normal',
  fontWeight: 600,
  lineHeight: '20px' /* 90.909% */,
  letterSpacing: '-0.44px',
  marginTop: 50,
  marginBottom: 50,
});

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
export const BottomWrapper = styled('div')(() => ({
  textAlign: 'center',
  fontSize: 13,
  fontWeight: 400,
  color: isDarkMode() ? colors.dark.black.secondary : colors.light.gray.light,
  letterSpacing: '-0.28px',
  padding: '0px 42px',
}));

export const textLinkStyle = {
  color: colors.light.blue.primary,
  textDecoration: 'underline',
  fontWeight: 700,
};
